import React from 'react';
import ReactDOM from 'react-dom/client';
import './styling_v2.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Set the app title
document.title = 'RioRegie - AI Task Assistant';

// Ensure light theme is the default on initial load (e.g. login page)
document.body.classList.add('light');
document.body.classList.remove('dark');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
